exports = module.exports = require("../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-scrollbar .el-scrollbar__bar{opacity:1 !important\n}\n", "", {"version":3,"sources":["/home/deploy/jsh/banniu-html/banniu.wap.html/src/App.vue"],"names":[],"mappings":";AACA,iCAAiC,oBAAoB;CACpD","file":"App.vue","sourcesContent":["\n.el-scrollbar .el-scrollbar__bar{opacity:1 !important\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0708d216","scoped":false,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = wSMK
// module chunks = 7